import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory } from 'react-router-dom'
//@ts-ignore
import classnames from "classnames";
import api from "../../../../../services/api";
import AuthContext from "../../../../../contexts/Auth";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";


import TermosUso from "./TermosUso";
import PoliticasPrivacidade from "./PoliticasPrivacidade";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import { HeaderContainer } from "./styles";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Nav,
  Row,
  Col,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Button,
} from "reactstrap";
import EmpresaContext from "../../../../../contexts/Empresa";

const TermosECondicoes: React.FC<any> = ({ hiddeTabs, history, ...props }) => {

  const [empresa, setEmpresa] = useState({});
  const [tabActive, setTabActive] = useState("termosuso");
  const [headerContent, setHeaderContent] = useState<any>(null);
  const [alert, setAlert] = useState(null);
  const notificationAlert = useRef<any>();
  const { empresaSelecionada } = useContext<any>(EmpresaContext)
  const { hasPermission, hasRole } = useContext(AuthContext);

  var externaTabActive = props.location.state?.externaTabActive ? props.location.state.externaTabActive : null;


  useEffect(() => {
      loadEmpresa(empresaSelecionada?.id);
  }, [empresaSelecionada]);

  useEffect(() => {
    if (externaTabActive && externaTabActive.length > 0) {
      setTabActive(externaTabActive);
    }
  }, [externaTabActive]);


  async function loadEmpresa(empresaId:number) {
    try {
      const response = await api.get(`/common/empresas/${empresaId}`);
      setEmpresa(response?.data);
    } catch (error) {
      console.log(error);
      notify("danger", "Não foi possível carregar empresa");
    }
  }

  const notify = (type:any, msg:string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text" style={{ zIndex: 100 }}>
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 3,
    };
    if (notificationAlert.current)
      notificationAlert.current.notificationAlert(options);
  };

  function onEmpresaChange(empresa:any) {
    setEmpresa(empresa ? empresa : {});
  }

  const CustomNavItem = ({ children, disabled, name }:any) => {
    return (
      <>
          <NavItem>
            <NavLink
              href="#"
              role="tab"
              className={classnames("mb-sm-3 mb-md-0 mt-2", {
                active: tabActive === name,
              })}
              onClick={() => setTabActive(name)}
              disabled={disabled}
            >
              {children}
            </NavLink>
          </NavItem>
        
      </>
    );
  };

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Termos e condições" parentName="Minha empresa" />
      <div className="w-100">
        <Card>
          <CardHeader>
            {headerContent ? headerContent : (
               <div className="d-flex justify-content-between align-items-center">
                <h1 className="mb-0">Termos e condições</h1>
               </div>
            )}
          </CardHeader>
          <CardBody outline body>
            <Row>
              <Col xs={12} lg={12} md={12} sm={12}>
                <div className="nav-wrapper">
                  <Nav
                    className="nav-fill flex-column flex-md-row"
                    pills
                    role="tablist"
                  >
                    <CustomNavItem name="termosuso" disabled={!empresaSelecionada.id}>
                      <>
                        <i className="fas fa-user mr-2" />
                        Termos de uso
                      </>
                    </CustomNavItem>
                    <CustomNavItem name="politicasprivacidade" disabled={!empresaSelecionada.id}>
                      <>
                        <i className="fas fa-user-friends mr-2" />
                        Políticas de privacidade
                      </>
                    </CustomNavItem>
                  </Nav>
                </div>
                <hr className="m-0" />
                <div>
                  <TabContent activeTab={tabActive}>
                    <TabPane tabId="termosuso">
                      {tabActive === "termosuso" && empresaSelecionada.id && (
                        <TermosUso
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          isActive={tabActive === "termosuso"}
                          setHeaderContent={setHeaderContent}
                        />
                      )}
                    </TabPane>
                    <TabPane tabId="politicasprivacidade">
                      {tabActive === "politicasprivacidade" && empresaSelecionada.id && (
                        <PoliticasPrivacidade
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          isActive={tabActive === "politicasprivacidade"}
                          setHeaderContent={setHeaderContent}
                        />
                      )}
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
export default TermosECondicoes;
